import React, { useRef, useEffect } from "react";
import Message from "./Message";
import { isCurrentUser } from "../../../../../api/sendbird";

export default ({ messages }) => {
  const messagesEndRef = useRef(null);
  const shouldRenderReciepts = message => {
    return isCurrentUser(message._sender);
  };
  const scrollToBottom = () => {
    messagesEndRef.current.scrollTop += messagesEndRef.current.scrollHeight;
  };
  useEffect(scrollToBottom, [messages]);
  return (
    <ol ref={messagesEndRef} id="messages" className="pl-3 d-block">
      {messages
        .slice(0)
        .reverse()
        .map(message => (
          <Message
            key={message.messageId}
            message={message}
            reciept={shouldRenderReciepts(message)}
          />
        ))}
    </ol>
  );
};
